import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import type { CalagemResult } from '../../../recommendations/types';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { mapCalagemResponse, type CalcularCalagemResponse } from './calagemResponse';

interface CalcularCalagemPayload {
	adviceId: string;
	productId: string;
	metodo: string;
	metodoValue: string;
	forma: string;
	formaConfig: {
		p: number;
		l: number;
		c: number;
	};
}

export function usePostAdviceCorrectionCalcularCalagem() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<CalagemResult, Error, CalcularCalagemPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<CalcularCalagemResponse | CalagemResult>(
					'/advices/planting/calcularCalagem',
					payload,
					{
						params: { forBinding },
					}
				);
				return mapCalagemResponse(data);
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular calagem');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['correction', 'calagem'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao calcular calagem:',
				getApiErrorMessage(error, 'Erro ao calcular calagem')
			);
		},
	});
}
